import React from "react";

import HomeUI from "../../ui/homeUI/_index";

const ScreenListPage = () => {
  return (
    <HomeUI />
  )
}

export default ScreenListPage;
